export const CFC_CONDITIONS = [
  { code: "trisomy_21", label: "Trisomy 21" },
  { code: "trisomy_18", label: "Trisomy 18" },
  { code: "trisomy_13", label: "Trisomy 13" },
  { code: "xxx_syndrome", label: "XXX syndrome" },
  { code: "xxy_syndrome", label: "XXY syndrome" },
  { code: "xyy_syndrome", label: "XYY syndrome" },
  { code: "del22q", label: "22q11.2 microdeletion" },
] as const;

export type CfcConditionCode = (typeof CFC_CONDITIONS)[number]["code"];

export interface CfcEligibleCondition {
  code: CfcConditionCode;
  label: string;
}
